var _path, _path2, _path3, _g, _path4, _path5, _g2, _path6, _path7, _path8, _path9, _g3, _g4, _g5, _g6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGrowingPlant(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "326.958px",
    height: "416.588px",
    viewBox: "333.886 191.412 326.958 416.588",
    enableBackground: "new 333.886 191.412 326.958 416.588",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#7CAD45",
    d: "M477.141,340.031c26.683-55.26,7.692-125.125,7.692-125.125s13.053,77.787-18.041,131.193 c-32.026,55-3.156,121.724-3.156,121.724l14.432-15.328c-14.583-21.979-16.047-47.828-13.864-68.162 C465.849,368.922,470.401,353.99,477.141,340.031"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#9D6345",
    d: "M448.308,526.567c-31.844-15.239-49.006-40.807-49.006-40.807s-18.563-19.506-29.072-14.698 c-10.511,4.813,1.65,23.386,1.65,23.386s56.646,52.947,56.771,54.744c0.125,1.803,102.213,6.797,102.213,6.797l21.808-17.822 l-15.948-8.131C536.724,530.036,480.146,541.802,448.308,526.567"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#B47552",
    d: "M431.614,518.88c-31.838-15.234-49-40.802-49-40.802s-18.563-19.511-29.072-14.698 c-10.511,4.808,1.65,23.381,1.65,23.381s56.641,52.953,56.771,54.75c0.13,1.802,102.219,6.797,102.219,6.797l21.797-17.823 l-15.948-8.136C520.031,522.349,463.458,534.12,431.614,518.88"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    x: 334.667,
    y: 457.333,
    width: 326.177,
    height: 126.667
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#SVGID_2_)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#BD7F5C",
    d: "M645.995,481.833l-39.328,4.688c-3.646,0.433-7.308-0.65-10.109-3.016 c-11.438-9.661-45.1-33.469-81.006-14.775c-33.744,17.572-58.26,19.104-67.994,18.844c-4.906-0.131-9.578,2.422-11.875,6.755 c-1.891,3.552-2.297,8.323,2.25,14.042c2.5,3.146,6.322,4.958,10.344,4.958l55.391,2.578c0,0-61.386,14.099-98.136-9.323 c-9.896-6.307-26.281-16.604-26.281-16.604c-1.792-0.975-3.339-2.339-4.516-4.006c-5.391-7.619-17.099-25.297-27.344-28.224 c-6.792-1.938-16.917,3.458-8.792,22.317c8.729,20.266,25.031,35.125,25.031,35.125l38.75,30.495 c0.334,0.261,0.672,0.505,1.026,0.734c5.833,3.75,57.198,36.333,80.547,36.438c0.474,0,0.953,0.016,1.422,0.073 c6.089,0.697,53.948,4.947,113.755-25.422c2.188-1.109,4.646-1.6,7.094-1.401l40.271,3.261c7.724,0.63,14.338-5.469,14.338-13.214 V495C660.833,487.058,653.891,480.891,645.995,481.833"
  })))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#D5946F",
    d: "M412.667,525.078c-30.688-17.442-46.006-44.156-46.006-44.156s-17.141-20.766-27.963-16.703 c-10.828,4.058,0,23.442,0,23.442s52.771,56.803,52.771,58.604c0,1.808,101.479,13.974,101.479,13.974L515.953,544l-15.333-9.239 C500.62,534.761,443.354,542.521,412.667,525.078"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#49302C",
    d: "M556.739,469.125c-1.51-2.969-3.063-5.917-4.614-8.859c-0.771-1.469-1.578-2.979-2.87-4.011 c-4.219-3.369-10.708-0.025-15.766-1.916c-5.036-1.891-7.947-8.703-13.322-8.433c-1.547,0.078-3.183,0.771-4.573,0.094 c-1.109-0.542-1.683-1.792-2.667-2.531c-1.005-0.761-2.338-0.906-3.599-0.953c-10.886-0.37-22.016,5.099-32.354,1.677 c-1.646-0.547-3.229-1.313-4.938-1.604c-7.13-1.209-13.135,5.927-20.344,6.572c-2.922,0.266-6.047-0.547-8.713,0.688 c-6.209,2.865-4.594,13.698-10.714,16.756c-2.146,1.072-4.75,0.838-6.964,1.771c-4.322,1.808-6.067,7.464-10.432,9.177 c-1.906,0.75-4.078,0.625-5.953,1.443c-7.256,3.15-4.563,16.552-11.928,19.438c-3.15,1.239-6.822-0.209-10.057,0.781 c-2.328,0.713-4.109,2.594-5.453,4.619c-6.365,9.604-3.844,24,5.406,30.865c3.541,2.63,7.744,4.172,11.906,5.635 c18.739,6.62,37.906,12.495,57.677,14.6c13.156,1.4,26.433,1.109,39.667,0.817c10.166-0.224,20.359-0.448,30.432-1.839 c4.917-0.682,10.219-1.875,13.365-5.713c3.713-4.526,3.281-11.339,6.677-16.104c2.438-3.422,6.464-5.271,9.724-7.922 c7.719-6.286,10.734-17.016,9.896-26.933C565.396,487.317,561.239,478,556.739,469.125"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_3_",
    x: 334.667,
    y: 480,
    width: 326.177,
    height: 128
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_4_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_3_",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#SVGID_4_)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#E3A378",
    d: "M645.995,505.38l-39.328,4.688c-3.646,0.433-7.308-0.656-10.109-3.021 c-11.438-9.656-45.1-33.464-81.006-14.771c-33.744,17.567-58.26,19.104-67.994,18.844c-4.906-0.136-9.578,2.422-11.875,6.75 c-1.891,3.557-2.297,8.328,2.25,14.041c2.5,3.151,6.322,4.964,10.344,4.964l55.391,2.573c0,0-61.386,14.099-98.136-9.318 c-9.896-6.313-26.281-16.609-26.281-16.609c-1.792-0.969-3.339-2.338-4.516-4c-5.391-7.625-17.099-25.297-27.344-28.224 c-6.792-1.942-16.917,3.453-8.792,22.317c8.729,20.261,25.031,35.125,25.031,35.125l38.75,30.495 c0.334,0.261,0.672,0.5,1.026,0.734c5.833,3.75,57.198,36.328,80.547,36.433c0.474,0,0.953,0.021,1.422,0.072 c6.089,0.698,53.948,4.953,113.755-25.416c2.188-1.115,4.646-1.604,7.094-1.406l40.271,3.266 c7.724,0.625,14.338-5.469,14.338-13.214v-51.156C660.833,510.599,653.891,504.438,645.995,505.38"
  })))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#2E9554",
    d: "M377.953,294.703c0,0,1.786,75.292,80.719,61.313C458.672,356.016,446.979,287.042,377.953,294.703"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#32A54D",
    d: "M478.516,343.906c49.839,33.813,82.651-25.328,82.651-25.328 C516.464,292.25,478.516,343.906,478.516,343.906"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#38B854",
    d: "M436.12,234.297c0,37.87,42.396,52.745,42.396,52.745C473.109,238.354,436.12,234.297,436.12,234.297"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#6BC634",
    d: "M493.401,241.958c23.005-3.156,28.869-29.302,28.869-29.302 C501.073,214.005,493.401,241.958,493.401,241.958"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_5_",
    x: 472,
    y: 191.412,
    width: 13.333,
    height: 24.588
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_6_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_5_",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#SVGID_6_)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#54BF36",
    d: "M472.156,191.469c-0.042,16.229,12.677,23.438,12.677,23.438 C486.636,197.328,472.156,191.469,472.156,191.469"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_7_",
    x: 334.667,
    y: 481.333,
    width: 326.177,
    height: 126.667
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_8_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_7_",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#SVGID_8_)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#D59671",
    d: "M543.208,562.828c-9.208,2.536-18.333,5.453-27.703,7.328c-14.208,2.849-28.775,3.245-43.266,3.526 c-11.838,0.224-23.822,0.364-35.364-2.308c-16.614-3.854-31.308-13.286-45.558-22.667c-13.588-8.942-27.333-18.188-37.521-30.864 c-8.125-10.104-13.739-22.859-13.817-35.636c-4.225,2.553-6.672,9.125-1.381,21.406c8.729,20.261,25.031,35.125,25.031,35.125 l38.75,30.495c0.334,0.261,0.672,0.5,1.026,0.734c5.833,3.75,57.198,36.328,80.547,36.433c0.474,0,0.953,0.021,1.422,0.072 c6.089,0.698,53.948,4.953,113.755-25.416c2.188-1.115,4.646-1.604,7.094-1.406l40.271,3.266 c7.724,0.625,14.338-5.469,14.338-13.214v-18.302C621.354,548.479,581.375,552.323,543.208,562.828"
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(52.854295, 15.650058)"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(150.189943, 15.650058)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrowingPlant);
export default __webpack_public_path__ + "static/media/growing_plant.da3068b418fbdf55261ce8a9ebfd94b0.svg";
export { ForwardRef as ReactComponent };